'use strict';
angular.module('weixinToBeCompiledModule', ['weixinToBeCompiledRouterModule', 'initWeiXinDataModule']).controller('weixinToBeCompiledCtrl', [
    '$scope',
    'wechatBtnService',
    'editIsLock',
    '$state',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
    'sensitiveWordCheckService',
    'editingCenterService',
    '$window',
    '$q',
    'trsPrintService',
    'editcenterRightsService',
    'storageListenerService',
    '$filter',
    'weixinConst',
    'newMediaService',
    'weixinService',
    function (
        $scope,
        wechatBtnService,
        editIsLock,
        $state,
        trsHttpService,
        trsspliceString,
        modalDialog,
        sensitiveWordCheckService,
        editingCenterService,
        $window,
        $q,
        trsPrintService,
        editcenterRightsService,
        storageListenerService,
        $filter,
        weixinConst,
        newMediaService,
        weixinService
    ) {
        initStatus();
        initData();
        weixinService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: [],
                printResult: [],
                trench: weixinConst.listenStroageKey,
            };
            $scope.status = {
                channelId: $state.params.wxchannelid,
                isOnlyMine: false,
                isSearch: false,
                copyCurrPage: 1,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
        }

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function () {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function () {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [showVersionTime description]展示流程版本与操作日志
         * @param  {[str]} item [description]
         * @return {[type]}            [description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [collect description] 稿件收藏
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.collect = function () {
            $scope.status.isSearch = false;
            $scope.loadingPromise = newMediaService.collect($scope, weixinConst.collectDB);
        };

        /**
         * [delete description] 废稿
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.delete = function () {
            $scope.status.isSearch = false;
            newMediaService.delete($scope, weixinConst.delete);
        };

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeixinListBtn('wechat.daibian', $scope.status.channelId).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [draftlist description] 发稿单
         * @return {[type]} [description]
         */
        $scope.draftlist = function () {
            $scope.status.isSearch = false;
            newMediaService.draftlist($scope, weixinConst.draftListDB, weixinConst.draftListQuery);
        };

        /**
         * [exportDraft description] 导出稿件
         * @return {[type]} [description]
         */
        $scope.exportDraft = function () {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isSearch = false;
            var params = {
                serviceid: 'mlf_exportword',
                methodname: 'exportWordFile',
                MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function (data) {
                    $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    requestData();
                },
                function (data) {
                    if (data.REPORTS[0].ISSUCCESS == 'true') {
                        $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
                    }
                }
            );
        };

        /**
         * [revoke description] 微信预览
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.wxPreview = function () {
            wechatBtnService.foregoingPreview($scope.data.selectedArray, 'daiBianPreview', '').then(() => {
                requestData();
            });
        };

        /**
         * [outSending description] 邮件外发
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.outSending = function () {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isSearch = false;
            editingCenterService.outSending('', function (result) {
                outSendingDraft(result.selectItems, $scope.data.selectedArray);
            });
        };

        /**
         * [outSendingDraft description] 邮件外发开始
         * @param  {[type]} items [description]
         * @param  {[type]} item  [description]
         * @return {[type]}       [description]
         */
        function outSendingDraft(items, item) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingoper',
                methodname: 'wechatDaiBianSendEmail',
                Emails: userids,
                MetaDataIds: draftids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                modalDialog.alertType('邮件外发成功', '', 'success', false, function () {
                    requestData();
                });
            });
        }

        /**
         * [printBtn description] 打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function () {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isSearch = false;
            angular.forEach($scope.data.selectedArray, function (value, key) {
                requestPrintData(value);
            });
        };

        /**
         * [selectDraftTip description] 选择稿件提示
         * @return {[boolean]} [description]
         */
        function selectDraftTip() {
            var flag = true;
            if ($scope.data.selectedArray.length === 0) {
                flag = false;
                modalDialog.alertType('请先选择稿件', '', 'warning', 'confirm');
            }
            return flag;
        }

        /**
         * [requestPrintData description] 打印请求详情
         * @param  {[type]} item    [description]
         * @param  {[type]} version [description]
         * @return {[type]}         [description]
         */
        function requestPrintData(item, version) {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'getNewsDoc',
                MetaDataId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                var result = data;
                data.VERSION = version;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                    trsPrintService.trsWeixinPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [trial description] 稿件送审
         * @return {[type]} [description]
         */
        $scope.trial = function () {
            $scope.status.isSearch = false;
            $scope.loadingPromise = newMediaService.trial($scope, weixinConst.trial);
            // var metaDataIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            // modalDialog.inputModel('送审', '送审意见（选填）', function(content) {
            //     var params = {
            //         serviceid: 'mlf_wechatoper',
            //         methodname: 'trialMetaDatas',
            //         MetaDataIds: metaDataIds,
            //         Opinion: content,
            //         CurrChnlId: $scope.status.channelId,
            //     };
            //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
            //         modalDialog.alertType('送审成功', '', 'success', false);
            //         requestData();
            //     });
            // });
        };

        /**
         * [sign description] 稿件送签
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.sign = function () {
            $scope.status.isSearch = false;
            var chnldocIDs = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
            sensitiveWordCheckService.SensitiveWordsAndCareful($scope.data.selectedArray, '', 4).then(
                function () {
                    $scope.status.signedSuccess = true;
                    sign(chnldocIDs);
                },
                function () {
                    sign(chnldocIDs);
                }
            );
        };

        /**
         * [sign description]  送签方法
         * @return  {[type]}  [return description]
         */
        function sign() {
            $scope.loadingPromise = newMediaService.sign($scope, weixinConst.daibianSign, function (params, array) {
                params.ObjectIds = params.ChnlDocIds = array.map(function (value, index) {
                    return value.DOC.CHNLDOCID;
                }).join(',');
            }
            );
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // requestData();
            initBtnRights();
            listenStorage();
        }

        $scope.requestData = function () {
            requestData();
        };

        /**
         * [requestData description] 获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            if (!$scope.status.isSearch) {
                commonReqeust();
            } else {
                searchRequest();
            }
        }
        $scope.requestData = requestData;

        /**
         * [fullTextSearch description] 搜索
         * @param   {[type]}  $event  [$event description]
         * @return  {[type]}          [return description]
         */
        $scope.fullTextSearch = function ($event) {
            if ($event !== undefined && $event.keyCode !== 13) {
                return;
            }
            $scope.status.isSearch = true;
            requestData();
        };

        /**
         * [requestListImg description] 查询列表图示
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {defer.resolve([]);} else {
                var params = {
                    serviceid: 'mlf_wechatgroupsend',
                    methodname: 'queryContentPics',
                    DocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [searchRequest description] 搜索请求
         * @return {[type]} [description]
         */
        function searchRequest() {
            var params = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForWeChatToBeCompiledDoc',
                searchParams: JSON.stringify({
                    PAGESIZE: $scope.page.PAGESIZE,
                    PAGEINDEX: $scope.page.CURRPAGE,
                    searchFields: [
                        {
                            searchField: '',
                            keywords: $scope.keywords ? $scope.keywords : '',
                        },
                        {
                            searchField: 'timeType',
                            keywords: !$scope.status.untildate ? '' : $scope.status.fromdate + ',' + $scope.status.untildate,
                        },
                        {
                            searchField: 'isOnlyMine',
                            keywords: $scope.status.isOnlyMine,
                        },
                        {
                            searchField: 'channelid',
                            keywords: $state.params.wxchannelid,
                        },
                        {
                            searchField: '_sort',
                            keywords: 'time',
                        },
                    ],
                }),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
                requestListImg(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                newMediaService.getReviseInfo($scope.data.items);
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID', 'weixinPreview');
            });
        }

        /**
         * [commonReqeust description] 普通请求
         * @return {[type]} [description]
         */
        function commonReqeust() {
            var params = {
                serviceid: 'mlf_wechat',
                methodname: 'queryToBeCompiledDoc',
                isOnlyMine: $scope.status.isOnlyMine,
                ChannelId: $state.params.wxchannelid,
                timeType: 0,
                OperTimeStart: $scope.status.fromdate,
                OperTimeEnd: $scope.status.untildate,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
                requestListImg(ListItems).then(function (data) {
                    angular.forEach(ListItems, function (value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                newMediaService.getReviseInfo($scope.data.items);
                storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,CHNLDOCID', 'weixinPreview');
            });
        }

        /**
         * [isOnlyMine description] 只看我的切换
         * @return {Boolean} [description]
         */
        $scope.isOnlyMine = function () {
            $scope.status.isOnlyMine = !$scope.status.isOnlyMine;
            requestData();
        };

        /**
         * [selectDoc description]单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [isLockEdit description] 编辑前请求解锁
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.isLockEdit = function (item) {
            $scope.status.isSearch = false;
            editIsLock.isLock(item, 4).then(function (data) {
                var editPath = 'wxeditpage';
                var editParams = {
                    wxchannelid: $scope.status.channelId,
                    wxchnldocid: item.CHNLDOCID,
                    wxmetadataid: item.METADATAID,
                    wxplatform: 0,
                    isawaitrevise: item.WEIXINSTATUSNAME === '待修订' ? 'isAwaitRevise' : '',
                };
                var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function () {
                        window.open(editUrl);
                    });
                }
            });
        };

        /**
         * [createDoc description] 新建稿件
         * @return {[type]} [description]
         */
        $scope.createDoc = function () {
            var url = $state.href('wxeditpage', { wxchannelid: $scope.status.channelId, wxplatform: 0 });
            window.open(url);
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenWeixin(function () {
                $scope.status.isSerach = false;
                requestData();
                storageListenerService.removeListener('weixin');
            }, $scope);
        }

        /**
         * [revise description] 修订方法
         *
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            var params = {
                serviceid: 'mlf_modifydoc',
                methodname: 'appointDocToUserOfNewMedia',
                SiteId: $state.params.siteid,
                DocIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                UserId: '',
                MediaType: '4',
            };
            newMediaService.revise($scope, params);
        };

        /**
         * [distribution description]多元分发
         *
         * @return  {[type]}  [return description]
         */
        $scope.distribution = function () {
            $scope.status.isSearch = false;
            if (!editingCenterService.isSameDocType($scope.data.selectedArray, 'DOCTYPEID')) {
                modalDialog.alertType('', '多元分发仅支持相同类型的稿件', 'warning', 'confirm', function () { });
                return;
            }
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDistributionType);
            if (temp.length < 1) {
                editingCenterService.distribution($scope.data.selectedArray, '4', $scope.data.selectedArray[0].DOCTYPEID, 'weChatDaiBianDistribute', function () {
                    $scope.data.selectedArray = [];
                    requestData();
                });
            } else {
                modalDialog.alertType('', '多元分发仅支持的稿件类型为图文', 'warning', 'confirm', function () { });
            }
        };

        /** 多元分发稿件类型  新闻:1、图集:2、链接:4、视频:8、app直播:7
         * [examDistributionType description]
         * @param  {[type]} elm [description]
         * @return {[type]}     [description]
         */
        $scope.examDistributionType = function (elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID != 1;
            }
        };
    },
]);
